import url from '@/creditflowresearch/infrastructure/url';
import staticUrls from '@finsight/urls/static';
import IDeal from '@/creditflowresearch/domain/vo/IDeal';
import { ICorporateDeal } from '@/creditflowresearch/domain/vo/Deals/CorporateDeal';

const getDealMetaSchema = (pathname: string, deal: IDeal | ICorporateDeal) => {
  const { seriesName, primaryIssuer: issuer } = deal;
  const series = seriesName || '';
  const issuerName = issuer?.name || '';
  const issuerTicker = issuer?.issuerTicker || '';
  const issuerSeries = `${ issuerName } (${ issuerTicker }) ${ series }`;
  const description = `View the ${ issuerSeries } fixed income deal profile here.`;

  return {
    '@type': 'ProfilePage',
    url: url.getUrl(pathname),
    name: `${ issuerSeries } Bond Profile`,
    description,
    keywords: [
      issuerName,
      `${ issuerTicker } ${ series }`,
      `${ issuerName } ${ issuerTicker } ${ series }`,
      'fixed income deal',
    ],
    hasPart: {
      '@type': 'Dataset',
      name: `${ issuerSeries } Bond Profile`,
      description: `View the ${ issuerSeries } deal profile`,
      license: staticUrls.getTermsOfUseUrl(),
    },
  };
};

export default getDealMetaSchema;
